import React from "react";
import { useForm } from "react-hook-form";

const Guidelines = (props) => {
  const { next, previous } = props;
  const { handleSubmit, register, errors } = useForm();
  return (
    <div className="container px-5 pt-5 custom-modal">
      <div className="row">
        <h2 className="text-capitalize">
          Become an <span className="text-lowercase">eksplode!</span> Retailer
        </h2>
      </div>
      <br />
      <div className="row">
        <h6>
          List your product(s) or service(s) and let our Members and Stars
          promote them through eksplode!'s Electronic Ad Card (EAC) and Video Ad
          Contest (VAC) programs.
          <br />
          eksplode! Marketing operates two unique programs that allow Retailers
          to reach a wider customer base and increase sales by using our
          peer-to-peer product placement programs, rewarding eksplode! Members
          with cash payments deducted from each sale processed through
          eksplode!, and, by rewarding eksplode! Stars with cash prizes for
          creating video ads promoting Retailer's products or services.
          <br />
          To become an eksplode! Retailer, simply sign up, select to participate
          in eksplode!'s EAC or VAC program (or both), then upload your product
          or service catalog on eksplode!'s platform.
        </h6>
      </div>

      <div className="row mt-3">
        <h3 className="text-dark font-weight-bold">Retailer's Guidelines</h3>
      </div>
      <div className="row">
        <ul>
          <li>
            Retailer's upload their catalog onto eksplode!'s EAC platform and
            select an amount (in USD or a percentage of the sales price) which
            they agree to reward an eksplode! Member for each item sold through
            their promotional efforts.
          </li>
          <li>
            eksplode!'s unique system then creates an Electronic Ad Card (EAC)
            for each product or service listed by the Retailer.
          </li>
          <li>
            Each EAC depicts a picture and description of the product or service
            offered by the Retailer.
          </li>
          <li>Each EAC also has a hyperlink tab.</li>
          <li>
            eksplode! Members review each EAC and download those they select to
            promote onto their eksplode! platform.
          </li>
          <li>
            Each EAC downloaded, and every EAC electronically transferred, is
            encrypted with that Member's eksplode! Code, which allows eksplode!
            Marketing to connect each sale made to the Member whose EAC was used
            to access the Retailer's eksplode! catalog.
          </li>
          <li>
            eksplode! Members then share their selected EACs with family,
            friends, peers, and followers through an electronic transfer.
          </li>
          <li>
            The EAC recipient then activates the hyperlink tab and is taken
            directly to the Retailer's catalog and the product or service
            depicted and described on the EAC.
          </li>
          <li>
            If the EAC recipient elects to buy the product or service promoted,
            or any other product or service from that Retailer's eksplode!
            catalog, the entire transaction is processed through eksplode!.
          </li>
          <li>
            In processing the transaction, the price of the product (or
            service), all applicable sales taxes and other fees (including
            eksplode!'s fee of 5%) are calculated and billed to the customer.
          </li>
          <li>
            Once the transaction is complete, eksplode! will automatically
            deduct the reward amount selected by the Retailer and deposit it
            into the account of the Member who promoted the product and caused
            the sale to occur.
          </li>
          <li>
            The Retailer will automatically receive a Purchase Notice and the
            remaining proceeds from the sale will be simultaneously deposited
            into its account of choice.
          </li>
          <li>
            There is no cost to become an eksplode! Retailer, and the rewards
            and eksplode! fees are only deducted if and when a product or
            service is purchased.
          </li>
        </ul>
      </div>
      <div className="row d-flex flex-column">
        <div className="d-flex justify-content-start mt-3 align-items-center">
          <input
            type="checkbox"
            className="form-control w-auto mr-3"
            id="read"
            name="read"
            ref={register({
              required: {
                value: true,
                message: "Please read the guidelines",
              },
            })}
          />
          <p className="mb-0">I have read the guidelines</p>
        </div>
        <label htmlFor="read" className="error mt-2">
          {errors.read && errors.read.message}
        </label>
      </div>
      <div className="row mt-3 justify-content-center">
        <button
          className="btn btn-solid mx-1"
          style={{ minWidth: "150px" }}
          onClick={previous}
        >
          Previous
        </button>
        <button
          className="btn btn-solid mx-1"
          style={{ minWidth: "150px" }}
          onClick={handleSubmit(next)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Guidelines;
